import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(value: number): string {
    let returnValue: string;
    if (value) {
      const hour = Math.floor(value / 3600);
      const minute = Math.floor(value % 3600 / 60);
      const second = Math.floor(value % 3600 % 60);
      const hourDisplay = hour > 0 ? hour + (hour === 1 ? "hr " : "hrs ") : "";
      const minuteDisplay = minute > 0 ? minute + (minute === 1 ? "min " : "mins ") : "";
      const secondDisplay = second > 0 ? second + (second === 1 ? "sec" : "secs") : "";
      returnValue = hourDisplay + minuteDisplay + secondDisplay; 
    }
    return returnValue;
  }

}
